<template>
    <BasePage>
        <div class="container mt-6 mb-7">
            <div class="row justify-content-center">
                <div class="col-12 col-md-8 col-lg-6">
                    <div class="text-center">
                        <img width="300" class="mw-100" src="/LarkhallOrderConfirmed.svg" alt="">
                        <h1 class="mt-6">Order Confirmed</h1>
                        <p>Thank you for your order.</p>
                    </div>
                    <div class="card mt-4" data-testid="what-next">
                        <div class="card-body">
                            <h2 class="h3">What happens next</h2>
                            <ol class="mb-0 ps-3">
                                <li class="mb-2">We have sent an order confirmation to your email address. Please check it, and keep it for your records.</li>
                                <li class="mb-2">The remaining balance is paid on the day of collection. If you chose delivery, a payment link will be sent to you for the remaining balance.</li>
                                <li>If the email has not arrived, or anything in it looks wrong, email us at <a href="mailto:info@larkhallbutchers.co.uk">info@larkhallbutchers.co.uk</a>.</li>
                            </ol>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap justify-content-center gap-2 mt-4">
                        <router-link class="btn btn-primary" to="/my-order">View my order</router-link>
                        <router-link class="btn btn-outline-secondary" to="/FAQ">Read the FAQ</router-link>
                    </div>
                </div>
            </div>
        </div>
    </BasePage>
</template>

<script>
import BasePage from '@/components/BasePage.vue';

export default {
    name: 'SuccessPage',
    components: {
        BasePage,
    },
    mounted() {
        // The API redirects here as plain /success with nothing that marks a real payment
        // (checkout.ts: deliveryPaymentSuccess), so the basket is cleared on every visit, as before.
        localStorage.removeItem('basketId2026')
        window.dispatchEvent(new CustomEvent('basket-changed'));
    }
};
</script>
